import { render, staticRenderFns } from "./CompanyEditDossiers.vue?vue&type=template&id=4f8bdf3d&"
import script from "./CompanyEditDossiers.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditDossiers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f8bdf3d')) {
      api.createRecord('4f8bdf3d', component.options)
    } else {
      api.reload('4f8bdf3d', component.options)
    }
    module.hot.accept("./CompanyEditDossiers.vue?vue&type=template&id=4f8bdf3d&", function () {
      api.rerender('4f8bdf3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEditDossiers.vue"
export default component.exports